import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptcha2Component } from 'ngx-captcha';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, fromEvent } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
declare let $: any
@Component({
  selector: 'app-google-fb-signup',
  templateUrl: './google-fb-signup.component.html',
})
export class GoogleFbSignupComponent implements OnInit {
  @ViewChild("testInput") testInput: any;
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @ViewChild('productKey') productKey: any
  @Output() isLogin = new EventEmitter<boolean>();
  isProducyKeyVerified: boolean = false;
  emailVerified: boolean = false;
  isSubmitted = false;
  getResponseOfGoogle: any;
  getEmail: any;
  getName: any;
  productKeyErrprMessage: any;
  errorMessage: any;
  counts: number = 0;
  showCaptcha: boolean = false;
  errorForVerification: boolean = false;
  language: any;
  signUpForm: FormGroup = new FormGroup({
    productKey: new FormControl(''),
    captchaToken: new FormControl(''),
  });
  currentLanguage: any = 'en';
  browserLang: any;
  languageCode = 'en';
  isInvalidEmail: boolean;
  invalidEmailStatMsg: any;
  socialLang: any;
  constructor(
    private _formBuilder: FormBuilder,
    private _service: ApiService,
    private _commonService: CommonService,
    private _router: Router,
    private _toastr: ToastrService,
    private _actRoute: ActivatedRoute, private translate: TranslateService
  ) {
    this.socialLang = localStorage.getItem('SocialSelectedLang');
    translate.addLangs(['en', 'fr', 'it']);
    translate.setDefaultLang('en');
    this.browserLang = this._service.getLanguageMap[this.socialLang] || 'en';
    this.translate.setDefaultLang(this.browserLang);
    this.translate.use(this.browserLang);
  }
  siteKey: string = '6Lc_wz4gAAAAACQb5G1tBuZS3IhTKUeuC6lj_YBv';
  signuoGoogleCode: string = ''
  ngOnInit(): void {
    this.signUpForm = this._formBuilder.group(
      {
        productKey: [''],
        captchaToken: ['']
      },
    );
    this.language = this.browserLang;
    this.signuoGoogleCode = this._actRoute.snapshot.queryParams["code"];
    if (this.signuoGoogleCode) {
      this.verifyAuthorizationCode();
    } else if (this._actRoute.snapshot.queryParams["error_description"]) {
      window.location.href = '/';
    }
    setTimeout(() => {
      this.testInput.nativeElement.focus();
    }, 1000);
  }

  ngAfterViewInit(): void {
  }



  get f(): { [key: string]: AbstractControl } {
    return this.signUpForm.controls;
  }


  // Verifying Authorization code when click from Email
  userExists: boolean = false;
  verifyAuthorizationCode() {
    try {
      let data = {
        "authorizationCode": this.signuoGoogleCode
      }
      this._service.postService(this._service.API_URL.verifyAuthorizationCode, data).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.getResponseOfGoogle = response.data;
          this.getEmail = response.data.email;
          this.getName = response.data.name;
          this.verifyEmailwithActivation();
        } else if (response && response.status.code === 400) {
          this.userExists = true;
          this.getEmail = response.data.email;
          this.getName = response.data.name;
          this.productKeyErrprMessage = response.status.message;
          this.errorMessage = response.status.message;
        } else {
          this.getEmail = response.data.email;
          this.getName = response.data.name;
          this.productKeyErrprMessage = response.status.message;
          this.errorMessage = response.status.message;
        }
      })
    } catch (error) {

    }
  }

  verifyEmailwithActivation() {
    let data = {
      userName: this.getEmail,
      langPref: localStorage.getItem('SocialSelectedLang') || 'ENGLISH',
    };
    this._service.postService(this._service.API_URL.verifyEmailwithActivation, data).subscribe((response: any) => {
      if (response && response.status.code === 200) {
        if (response.status.msgCode === 'EMAIL_DOESNT_EXIST_WITH_ANY_PRODUCT_KEY') {
          this.isInvalidEmail = true;
          this.invalidEmailStatMsg = response?.status?.message;
        }
        else {
          this.isInvalidEmail = false;
        }
      } else if (response && response.status.code === 400) {
        this.isInvalidEmail = true;
        this.invalidEmailStatMsg = response?.status?.message;
      }
      if (response.status.msgCode === 'EMAIL_DOESNT_EXIST_WITH_ANY_PRODUCT_KEY' || response.status.msgCode === 'USER_EXIST_WITH_EMAIL') {
        this.isInvalidEmail = true;
        this.invalidEmailStatMsg = response?.status?.message;
      }
    });
  }

  // Submitting Data for signup
  onSubmit() {
    try {
      this.isSubmitted = true;
      let data = {
        name: this.getResponseOfGoogle.name,
        email: this.getResponseOfGoogle.email,
        productKey: this.signUpForm.controls['productKey'].value,
        authorizationCode: this.signuoGoogleCode,
        captchaToken: this.signUpForm?.controls['captchaToken']?.value,
      };
      this._service.postService(this._service.API_URL.signup, data).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.signUpForm.reset();
          this.isProducyKeyVerified = false;
          this.emailVerified = false;
          $('#signupSuccess').modal("show")
        } else {
          this.errorMessage = response.status.message;
        }
      });
    } catch (e) { }
  }
  clearProductfield(e: any) {
    if (e.key == 'Backspace') {
      this.errorForVerification = false;
      if (this.signUpForm.controls['productKey'].value?.length === 20) {
        let data = {
          productKey: this.signUpForm.controls['productKey'].value,
        };
        this._service.postService(this._service.API_URL.verifyProductKey, data).subscribe((response: any) => {
          if (response && response.status.code === 200) {
            if (response.data.isProductKeyExists === true) {
              this.isProducyKeyVerified = true;
            } else {
              this.counts++;
              if (this.counts >= 3) {
                this.showCaptcha = true;
                this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
                this.counts = 0;
              }
              else {
                this.showCaptcha = false;
              }
            }
            this.errorForVerification = false;
            this.productKeyErrprMessage = response.status.message;
          } else {
            this.counts++;
            if (this.counts >= 3) {
              this.showCaptcha = true;
              this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
              this.counts = 0;
            }
            else {
              this.showCaptcha = false;
            }
            this.isProducyKeyVerified = false;
            this.productKeyErrprMessage = response.status.message;
            this.errorForVerification = true;
          }
        });
      }
    }

  }


  goToLoginPage() {
    $('#signupSuccess').modal("hide")
    this._router.navigate(['/']);
  }

  ngAfterContentChecked() {
    if (this.isPaste === true) {
      this.isPaste = false

      setTimeout(() => {
        let data = {
          productKey: this.signUpForm.controls['productKey'].value.split('-').join(''),
        };
        if (this.signUpForm.controls['productKey'].value?.length > 20) {
          this._service.postService(this._service.API_URL.verifyProductKey, data).subscribe((response: any) => {
            if (response && response.status.code === 200) {
              if (response.data.isProductKeyExists === true) {
                this.isProducyKeyVerified = true;
              } else {
                if (this.signUpForm.controls['captchaToken'].value) {
                  this.captchaElem.reloadCaptcha();
                  this.signUpForm.controls['captchaToken'].setValue(null)
                  this.isProducyKeyVerified = false;
                  this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
                }
                this.counts++;
                if (this.counts >= 3) {
                  this.showCaptcha = true;
                  this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
                  // this.counts = 0;
                }
                else {
                  this.showCaptcha = false;
                }
              }
              this.errorForVerification = false;
              this.productKeyErrprMessage = response.status.message;
            } else {
              if (this.signUpForm.controls['captchaToken'].value) {
                this.captchaElem.reloadCaptcha();
                this.signUpForm.controls['captchaToken'].setValue(null)
                this.isProducyKeyVerified = false;
                this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
              }
              this.counts++;
              if (this.counts >= 3) {
                this.showCaptcha = true;
                this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
                // this.counts = 0;
              }
              else {
                this.showCaptcha = false;
              }
              this.isProducyKeyVerified = false;
              this.productKeyErrprMessage = response.status.message;
              this.errorForVerification = true;
            }
          });
        }


      }, 2000);

    }
  }

  isPaste: boolean = false;
  pasteEvent() {
    this.isPaste = true;
  }
  keyPressAlphaNumericWithCharacters(event: any) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  removeSpace(event: any) {
    if (event.code === "Space") {
      event.preventDefault()
    }

  }

  getLanguageMap: { [key: string]: string } = {
    ENGLISH: 'en',
    SPANISH: 'es',
    ITALIAN: 'it'
  };

}
